<template>
    <div>
        <!-- Dialog -->
        <el-dialog
            :visible.sync="visible"
            :before-close="handleClose"
        >
            <!-- Header -->
            <template slot="title">
                <h5 class="text-dark mb-0">A2P Profile Bundle Review 📝</h5>
            </template>

            <!-- Content -->
            <el-form>
                <div class="row">
                    <div v-if="customer_profile_evaluation" class="col-12 mb-2">
                        <el-alert
                            v-if="isCustomerProfileCompliant"
                            show-icon
                            type="success"
                            :closable="false"
                        >
                            <span class="text-dark">
                                Customer Profile is <b>Compliant</b>.
                            </span>
                        </el-alert>
                        <el-alert
                            v-if="isCustomerProfileNonCompliant"
                            show-icon
                            type="error"
                            class="mb-2"
                            :closable="false"
                        >
                            <span class="text-dark">
                                Customer Profile Evaluation is <b>Non-Compliant</b>.
                            </span>
                        </el-alert>
                        <el-alert
                            v-if="isA2pProfileBundleNonCompliant"
                            show-icon
                            type="error"
                            class="mb-2"
                            :closable="false"
                        >
                            <span class="text-dark">
                                A2P Profile Bundle Evaluation is <b>Non-Compliant</b>.
                            </span>
                        </el-alert>
                    </div>
                    <div class="col-12">
                        <div class="row">
                            <!-- Business Information -->
                            <div class="col-12 mb-2">
                                <span class="text-dark h6"><i class="material-icons mr-2">business</i>Business Information</span>
                            </div>

                            <div class="col-6">
                                <!-- Business Name -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Business Name</span>
                                    </div>
                                    <div class="pl-2 d-flex align-items-center">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="businessNameTooltip"
                                        >
                                            <i v-if="businessNamePassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.business_name" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-6">
                                <!-- Website URL -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Website URL</span>
                                    </div>
                                    <div class="pl-2 d-flex align-items-center">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="websiteUrlTooltip"
                                        >
                                            <i v-if="websiteUrlPassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.website_url" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-3">
                                <!-- Company Type -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Company Type</span>
                                    </div>
                                    <div class="pl-2 d-flex align-items-center">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="companyTypeTooltip"
                                        >
                                            <i v-if="companyTypePassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-select
                                        :disabled="true"
                                        v-model="brand_information.company_type"
                                        class="w-full"
                                        placeholder="Select Company Type"
                                        filterable
                                    >
                                        <el-option
                                            label="Private"
                                            :value="STATUS_PRIVATE"
                                        />
                                        <el-option
                                            label="Public"
                                            :value="STATUS_PUBLIC"
                                        />
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="col-4">
                                <!-- Business Type -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Business Type</span>
                                    </div>
                                    <div class="pl-2 d-flex align-items-center">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="businessTypeTooltip"
                                        >
                                            <i v-if="businessTypePassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-select
                                        :disabled="true"
                                        v-model="brand_information.business_type"
                                        class="w-full"
                                        placeholder="Select Registration Type"
                                        filterable
                                    >
                                        <el-option
                                            v-for="business_type in BusinessTypes"
                                            :key="business_type.id + business_type.value"
                                            :label="business_type.value"
                                            :value="business_type.value"
                                        />
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="col-5">
                                <!-- Business Industry -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Business Industry</span>
                                    </div>
                                    <div class="pl-2 d-flex align-items-center">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="businessIndustryTooltip"
                                        >
                                            <i v-if="businessIndustryPassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-select
                                        :disabled="true"
                                        v-model="brand_information.business_industry"
                                        class="w-full"
                                        placeholder="Select Business Industry"
                                        filterable
                                    >
                                        <el-option
                                            v-for="industry in BusinessIndustries"
                                            :key="industry.id + industry.value"
                                            :label="industry.name"
                                            :value="industry.value"
                                        />
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="col-4" v-if="brand_information.company_type === STATUS_PUBLIC">
                                <!-- Stock Ticker -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Stock Ticker</span>
                                    </div>
                                    <div class="pl-2 d-flex align-items-center">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="stockTickerTooltip"
                                        >
                                            <i v-if="stockTickerPassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.stock_ticker" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-4" v-if="brand_information.company_type === STATUS_PUBLIC">
                                <!-- Stock Exchange -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Stock Exchange</span>
                                    </div>
                                    <div class="pl-2 d-flex align-items-center">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="stockExchangeTooltip"
                                        >
                                            <i v-if="stockExchangePassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-select
                                        :disabled="true"
                                        v-model="brand_information.stock_exchange"
                                        placeholder="Select Stock Exchange"
                                        class="w-full"
                                        filterable
                                        @change="preValidateForm('customerProfileRegistrationForm')"
                                    >
                                        <el-option
                                            v-for="stock_exchange in StockExchanges"
                                            :key="stock_exchange.id + stock_exchange.value"
                                            :label="stock_exchange.value"
                                            :value="stock_exchange.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="col-4" v-if="brand_information.company_type === STATUS_PUBLIC">
                                <!-- Brand Contact Email -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Brand Contact Email</span>
                                    </div>
                                    <div class="pl-2 d-flex">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="brandContactEmailTooltip"
                                        >
                                            <i v-if="brandContactEmailPassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.brand_contact_email" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-12">
                                <!-- Regions of Operation -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Regions of Operation</span>
                                    </div>
                                    <div class="pl-2 d-flex align-items-center">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="businessRegionsOfOperationTooltip"
                                        >
                                            <i v-if="businessRegionsOfOperationPassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-select
                                        :disabled="true"
                                        v-model="brand_information.business_regions_of_operation"
                                        class="w-full"
                                        placeholder="Select Regions of Operation"
                                        multiple
                                        clearable
                                        filterable
                                    >
                                        <el-option
                                            v-for="region in RegionsOfOperation"
                                            :key="region.id + region.value"
                                            :label="region.name"
                                            :value="region.value"
                                        />
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="col-6">
                                <!-- Business Registration Identifier -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Business Registration Identifier</span>
                                    </div>
                                    <div class="pl-2 d-flex align-items-center">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="businessRegistrationIdentifierTooltip"
                                        >
                                            <i v-if="businessRegistrationIdentifierPassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-select
                                        :disabled="true"
                                        v-model="brand_information.business_registration_identifier"
                                        class="w-full"
                                        placeholder="Select Business Registration Identifier"
                                        filterable
                                    >
                                        <!--
                                            Render the current value.
                                            If it's not in the list of BusinessIdentifiers, it means it was Other Identifier
                                         -->
                                        <el-option
                                            v-if="!BusinessIdentifiers.some(identifier => identifier.value === brand_information.business_registration_identifier)"
                                            :label="brand_information.business_registration_identifier"
                                            :value="brand_information.business_registration_identifier"
                                        />
                                        <!-- Render everything else -->
                                        <el-option
                                            v-for="identifier in BusinessIdentifiers"
                                            v-show="brand_information.business_registration_identifier !== identifier.value"
                                            :key="identifier.id + identifier.value"
                                            :label="identifier.name"
                                            :value="identifier.value"
                                        />
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="col-6">
                                <!-- Business Registration Number -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Business Registration Number</span>
                                    </div>
                                    <div class="pl-2 d-flex align-items-center">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="businessRegistrationNumberTooltip"
                                        >
                                            <i v-if="businessRegistrationNumberPassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.business_registration_number" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-6">
                                <!-- Business Registration Number -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Business Registration Document</span>
                                    </div>
                                </div>
                                <el-form-item>
                                    <!-- v-for to support multi docs -->
                                    <div v-for="download_link in brand_information.download_links" :key="download_link">
                                        <p v-if="download_link">
                                            <a
                                                :href="download_link"
                                                target="_blank"
                                                class="text-blue font-weight-bold"
                                            >
                                                View Document
                                            </a>
                                        </p>
                                    </div>
                                </el-form-item>
                            </div>

                            <!-- Business Address -->
                            <div class="col-12 mb-2">
                                <span class="text-dark h6 d-flex align-items-center">
                                    <i class="material-icons mr-2">home</i>Business Address
                                    <el-tooltip
                                        effect="dark"
                                        placement="top"
                                        :content="addressTooltip"
                                        class="ml-2"
                                    >
                                        <i v-if="addressPassed" class="material-icons text-green">check_circle_outline</i>
                                        <i v-else class="material-icons text-danger">cancel</i>
                                    </el-tooltip>
                                </span>
                            </div>
                            <div class="col-4">
                                <!-- Street 1 -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Street</span>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.street" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-4">
                                <!-- Street 2 -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Street 2</span>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.street_secondary" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-4">
                                <!-- City -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">City</span>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.city" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-4">
                                <!-- Region -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Region</span>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.region" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-4">
                                <!-- Postal Code -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Postal Code</span>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.postal_code" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-4">
                                <!-- Country -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Country</span>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-select
                                        :disabled="true"
                                        v-model="brand_information.country"
                                        placeholder="Select Country"
                                        class="w-full"
                                        filterable
                                    >
                                        <el-option
                                            v-for="country in countries"
                                            :key="country.id"
                                            :label="country.name"
                                            :value="country.id"
                                        />
                                    </el-select>
                                </el-form-item>
                            </div>

                            <!-- Authorized Representative 1 -->
                            <div class="col-12 mb-2">
                                <span class="text-dark h6"><i class="material-icons mr-2">person</i>Authorized Representative</span>
                            </div>

                            <div class="col-4">
                                <!-- First Name -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">First Name</span>
                                    </div>
                                    <div class="pl-2 d-flex">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="firstNameTooltip"
                                        >
                                            <i v-if="firstNamePassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.first_name" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-4">
                                <!-- Last Name -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Last Name</span>
                                    </div>
                                    <div class="pl-2 d-flex">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="lastNameTooltip"
                                        >
                                            <i v-if="lastNamePassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.last_name" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-4">
                                <!-- Email -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Email</span>
                                    </div>
                                    <div class="pl-2 d-flex">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="emailTooltip"
                                        >
                                            <i v-if="emailPassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.email" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-4">
                                <!-- Phone Number -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Phone Number</span>
                                    </div>
                                    <div class="pl-2 d-flex">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="phoneNumberTooltip"
                                        >
                                            <i v-if="phoneNumberPassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.phone_number" :disabled="true"/>
                                </el-form-item>
                            </div>
                            <div class="col-4">
                                <!-- Job Position -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Job Position</span>
                                    </div>
                                    <div class="pl-2 d-flex">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="jobPositionTooltip"
                                        >
                                            <i v-if="jobPositionPassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-select
                                        :disabled="true"
                                        v-model="brand_information.job_position"
                                        placeholder="Select Job Position"
                                        class="w-full"
                                        filterable
                                    >
                                        <el-option
                                            v-for="job_positions in JobPositions"
                                            :key="job_positions.id"
                                            :label="job_positions.value"
                                            :value="job_positions.value"
                                        />
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="col-4">
                                <!-- Business Title -->
                                <div class="d-flex align-items-center mb-2">
                                    <div class="d-flex">
                                        <span class="text-dark">Business Title</span>
                                    </div>
                                    <div class="pl-2 d-flex">
                                        <el-tooltip
                                            effect="dark"
                                            placement="top"
                                            :content="businessTitleTooltip"
                                        >
                                            <i v-if="businessTitlePassed" class="material-icons text-green">check_circle_outline</i>
                                            <i v-else class="material-icons text-danger">cancel</i>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <el-form-item>
                                    <el-input v-model="brand_information.business_title" :disabled="true"/>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="row">
                            <div class="ml-auto col-4">
                                <el-button
                                    type="danger"
                                    class="btn-block"
                                    @click="openFailureReasonDialog"
                                    :disabled="disableRejectButton"
                                    :loading="reject_button_loading"
                                >
                                    Reject
                                </el-button>
                            </div>
                            <div class="col-4">
                                <el-button
                                    type="primary"
                                    class="btn-block"
                                    @click="openConfirmationDialog"
                                    :disabled="disableSubmitButton"
                                    :loading="submit_button_loading"
                                >
                                    Submit to Twilio
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-form>
        </el-dialog>

        <!-- Failure Reason Dialog -->
        <el-dialog
            :visible.sync="show_failure_reason_dialog"
            :before-close="closeFailureReasonDialog"
            title="Failure Reason"
            width="30%"
        >
            <div class="row">
                <div class="col-12 mb-3">
                    <el-input
                        type="textarea"
                        :rows="4"
                        v-model="failure_reason"
                        placeholder="Enter the reason for rejecting the A2P Brand"
                    />
                </div>
                <div class="col-12 text-right">
                    <el-button
                        type="danger"
                        @click="rejectA2pBrand"
                        :disabled="disableRejectButton"
                        :loading="reject_button_loading"
                    >
                        Reject
                    </el-button>
                </div>
            </div>
        </el-dialog>

        <!-- Confirmation Dialog -->
        <el-dialog
            :visible.sync="show_confirmation_dialog"
            :before-close="closeConfirmationDialog"
            title="Confirmation"
            width="30%"
        >
            <p>Are you sure you want <b>Submit this A2P Brand</b> to Twilio?</p>
            <div class="row mt-3">
                <div class="col-12 text-right">
                    <el-button
                        type="primary"
                        @click="submitToTwilio"
                        :disabled="disableSubmitButton"
                        :loading="submit_button_loading"
                    >
                        Confirm
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {STATUS_PRIVATE, STATUS_PUBLIC} from '../../../constants/company'
import BusinessIdentifiers from '../../../constants/compliance-business-registration-identifiers'
import BusinessIndustries from '../../../constants/compliance-business-industries'
import BusinessTypes from '../../../constants/compliance-business-types'
import JobPositions from '../../../constants/compliance-auth-rep-job-positions'
import RegionsOfOperation from '../../../constants/compliance-business-regions-of-operation'
import StockExchanges from '../../../constants/compliance-stock-exchanges'
import * as ComplianceBundleStatuses from '../../../constants/compliance-bundle-statuses'
import {compliance_mixin} from '../../../mixins'

export default {
    name: 'A2pBrandReviewDialog',
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        a2p_profile_bundle_id: {
            default: null,
            required: false,
        },
    },
    mixins: [
        compliance_mixin,
    ],
    data() {
        return {
            STATUS_PRIVATE,
            STATUS_PUBLIC,
            BusinessIdentifiers,
            BusinessIndustries,
            BusinessTypes,
            JobPositions,
            RegionsOfOperation,
            ComplianceBundleStatuses,
            StockExchanges,
            submit_button_loading: false,
            reject_button_loading: false,
            show_confirmation_dialog: false,
            show_failure_reason_dialog: false,
            failure_reason: null,
            countries: [],
            brand_information: {
                customer_name: null,
                website_url: null,
                company_type: null,
                stock_ticker: null,
                stock_exchange: null,
                business_type: null,
                business_industry: null,
                business_regions_of_operation: [],
                business_registration_identifier: null,
                other_identifier: null,
                business_registration_number: null,
                street: null,
                street_secondary: null,
                city: null,
                state: null,
                postal_code: null,
                country: null,
                first_name: null,
                last_name: null,
                email: null,
                brand_contact_email: null,
                phone_number: null,
                job_position: null,
                business_title: null,
            },
            customer_profile_evaluation: null,
            a2p_profile_bundle_evaluation: {
                status: null,
                passed: false,
            },
            customer_profile_business_information: {
                fields: {},
            },
            customer_profile_address: {
                fields: {},
            },
            authorized_representative_1: {
                fields: {},
            },
            us_a2p_messaging_profile_information: {
                fields: {},
            },
        }
    },
    created() {
        this.getA2pBrandInformation()
        this.countries = this.getCountries()
    },
    methods: {
        handleClose() {
            this.$emit('close');
        },
        getA2pBrandInformation() {
            // Prevent request if no a2p_profile_bundle_id
            if (!this.a2p_profile_bundle_id) {
                console.error('No A2P Profile Bundle selected', this.a2p_profile_bundle_id)
                return
            }

            axios
                .get(`/api/admin/compliance/a2p-profile-bundles/${this.a2p_profile_bundle_id}/brand-information`)
                .then((res) => {
                    this.customer_profile_business_information = res.data.customer_profile_evaluation.results?.customer_profile_business_information
                    this.customer_profile_address = res.data.customer_profile_evaluation.results?.customer_profile_address
                    this.authorized_representative_1 = res.data.customer_profile_evaluation.results?.authorized_representative_1
                    this.us_a2p_messaging_profile_information = res.data.a2p_profile_bundle_evaluation.results?.us_a2p_messaging_profile_information

                    // Clean up response
                    delete res.data.customer_profile_evaluation.results
                    delete res.data.a2p_profile_bundle_evaluation.results

                    this.customer_profile_evaluation = res.data.customer_profile_evaluation
                    this.a2p_profile_bundle_evaluation = res.data.a2p_profile_bundle_evaluation

                    // Clean up response
                    delete res.data.customer_profile_evaluation
                    delete res.data.a2p_profile_bundle_evaluation

                    this.brand_information = res.data
                })
                .catch((err) => {
                    this.$root.handleErrors(err.response)
                })
        },
        submitToTwilio() {
            this.submit_button_loading = true
            axios
                .post(`/api/admin/compliance/a2p-profile-bundles/${this.a2p_profile_bundle_id}/submit-brand`)
                .then((res) => {
                    this.submit_button_loading = false
                    this.$message.success('A2P Brand submitted to Twilio successfully.')
                    this.handleClose()
                })
                .catch((error) => {
                    this.submit_button_loading = false
                    let message = 'Request failed' // Default error message
                    if (error.response && error.response.data && error.response.data.message) {
                        // Extract the message from the response data
                        message = error.response.data.message
                    } else if (error.response && error.response.statusText) {
                        // Use statusText if no message is present in data
                        message = error.response.statusText
                    } else if (error.message) {
                        // Last resort: the error message Axios provides
                        message = error.message
                    }

                    this.$message({
                        message: message,
                        type: 'error',
                    })
                })
        },
        openFailureReasonDialog() {
            this.show_failure_reason_dialog = true
        },
        closeFailureReasonDialog() {
            this.show_failure_reason_dialog = false
        },
        openConfirmationDialog() {
            this.show_confirmation_dialog = true
        },
        closeConfirmationDialog() {
            this.show_confirmation_dialog = false
        },
        rejectA2pBrand() {
            this.reject_button_loading = true

            axios
                .post(`/api/admin/compliance/a2p-profile-bundles/${this.a2p_profile_bundle_id}/reject-brand`, {
                    'failure_reason': this.failure_reason,
                })
                .then((res) => {
                    this.reject_button_loading = false
                    this.$message.success('A2P Brand Rejected successfully.')
                    this.closeFailureReasonDialog()
                    this.handleClose()
                })
                .catch((err) => {
                    this.reject_button_loading = false
                    let message = 'Request failed' // Default error message
                    if (error.response && error.response.data && error.response.data.message) {
                        // Extract the message from the response data
                        message = error.response.data.message
                    } else if (error.response && error.response.statusText) {
                        // Use statusText if no message is present in data
                        message = error.response.statusText
                    } else if (error.message) {
                        // Last resort: the error message Axios provides
                        message = error.message
                    }

                    this.$message({
                        message: message,
                        type: 'error',
                    })
                })
        },
    },
    computed: {
        isCustomerProfileCompliant() {
            return this.customer_profile_evaluation.status === 'compliant' && this.companyTypePassed
        },
        isCustomerProfileNonCompliant() {
            return this.customer_profile_evaluation.status === 'non-compliant' || !this.companyTypePassed
        },
        isA2pProfileBundleNonCompliant() {
            return !this.companyTypePassed ||
                !this.stockTickerPassed ||
                !this.stockExchangePassed
        },
        businessNamePassed() {
            return this.customer_profile_business_information.fields?.business_name?.passed
        },
        businessNameFailureReason() {
            return this.customer_profile_business_information.fields?.business_name?.failure_reason
        },
        businessNameTooltip() {
            return this.businessNamePassed ? 'Passed' : this.businessNameFailureReason
        },
        websiteUrlPassed() {
            return this.customer_profile_business_information.fields?.website_url?.passed
        },
        websiteUrlFailureReason() {
            return this.customer_profile_business_information.fields?.website_url?.failure_reason
        },
        websiteUrlTooltip() {
            return this.websiteUrlPassed ? 'Passed' : this.websiteUrlFailureReason
        },
        companyTypePassed() {
            return this.us_a2p_messaging_profile_information?.fields?.company_type?.passed
        },
        companyTypeFailureReason() {
            return this.us_a2p_messaging_profile_information?.fields?.company_type?.failure_reason
        },
        companyTypeTooltip() {
            return this.companyTypePassed ? 'Passed' : this.companyTypeFailureReason
        },
        businessTypePassed() {
            return this.customer_profile_business_information.fields?.business_type?.passed
        },
        businessTypeFailureReason() {
            return this.customer_profile_business_information.fields?.business_type?.failure_reason
        },
        businessTypeTooltip() {
            return this.businessTypePassed ? 'Passed' : this.businessTypeFailureReason
        },
        businessIndustryPassed() {
            return this.customer_profile_business_information.fields?.business_industry?.passed
        },
        businessIndustryFailureReason() {
            return this.customer_profile_business_information.fields?.business_industry?.failure_reason
        },
        businessIndustryTooltip() {
            return this.businessIndustryPassed ? 'Passed' : this.businessIndustryFailureReason
        },
        stockTickerPassed() {
            return this.us_a2p_messaging_profile_information?.fields?.stock_ticker?.passed
        },
        stockTickerFailureReason() {
            return this.us_a2p_messaging_profile_information?.fields?.stock_ticker?.failure_reason
        },
        stockTickerTooltip() {
            return this.stockTickerPassed ? 'Passed' : this.stockTickerFailureReason
        },
        stockExchangePassed() {
            return this.us_a2p_messaging_profile_information?.fields?.stock_exchange?.passed
        },
        stockExchangeFailureReason() {
            return this.us_a2p_messaging_profile_information?.fields?.stock_exchange?.failure_reason
        },
        stockExchangeTooltip() {
            return this.stockExchangePassed ? 'Passed' : this.stockExchangeFailureReason
        },
        brandContactEmailPassed() {
            return this.us_a2p_messaging_profile_information.fields?.brand_contact_email?.passed || this.emailPassed
        },
        brandContactEmailFailureReason() {
            return this.us_a2p_messaging_profile_information.fields?.brand_contact_email?.failure_reason || ''
        },
        brandContactEmailTooltip() {
            return this.brandContactEmailPassed ? 'Passed' : this.brandContactEmailFailureReason
        },
        businessRegionsOfOperationPassed() {
            return this.customer_profile_business_information.fields?.business_regions_of_operation?.passed
        },
        businessRegionsOfOperationFailureReason() {
            return this.customer_profile_business_information.fields?.business_regions_of_operation?.failure_reason
        },
        businessRegionsOfOperationTooltip() {
            return this.regionsOfOperationPassed ? 'Passed' : this.regionsOfOperationFailureReason
        },
        businessRegistrationIdentifierPassed() {
            return this.customer_profile_business_information.fields?.business_registration_identifier?.passed
        },
        businessRegistrationIdentifierFailureReason() {
            return this.customer_profile_business_information.fields?.business_registration_identifier?.failure_reason
        },
        businessRegistrationIdentifierTooltip() {
            return this.businessRegistrationIdentifierPassed ? 'Passed' : this.businessRegistrationIdentifierFailureReason
        },
        businessRegistrationNumberPassed() {
            return this.customer_profile_business_information.fields?.business_registration_number?.passed
        },
        businessRegistrationNumberFailureReason() {
            return this.customer_profile_business_information.fields?.business_registration_number?.failure_reason
        },
        businessRegistrationNumberTooltip() {
            return this.businessRegistrationNumberPassed ? 'Passed' : this.businessRegistrationNumberFailureReason
        },
        addressPassed() {
            return this.customer_profile_address.fields?.address_sids?.passed
        },
        addressFailureReason() {
            return this.customer_profile_address.fields?.address_sids?.failure_reason
        },
        addressTooltip() {
            return this.addressPassed ? 'Passed' : this.addressFailureReason
        },
        firstNamePassed() {
            return this.authorized_representative_1.fields?.first_name?.passed
        },
        firstNameFailureReason() {
            return this.authorized_representative_1.fields?.first_name?.failure_reason
        },
        firstNameTooltip() {
            return this.firstNamePassed ? 'Passed' : this.firstNameFailureReason
        },
        lastNamePassed() {
            return this.authorized_representative_1.fields?.last_name?.passed
        },
        lastNameFailureReason() {
            return this.authorized_representative_1.fields?.last_name?.failure_reason
        },
        lastNameTooltip() {
            return this.lastNamePassed ? 'Passed' : this.lastNameFailureReason
        },
        emailPassed() {
            return this.authorized_representative_1.fields?.email?.passed
        },
        emailFailureReason() {
            return this.authorized_representative_1.fields?.email?.failure_reason
        },
        emailTooltip() {
            return this.emailPassed ? 'Passed' : this.emailFailureReason
        },
        phoneNumberPassed() {
            return this.authorized_representative_1.fields?.phone_number?.passed
        },
        phoneNumberFailureReason() {
            return this.authorized_representative_1.fields?.phone_number?.failure_reason
        },
        phoneNumberTooltip() {
            return this.phoneNumberPassed ? 'Passed' : this.phoneNumberFailureReason
        },
        jobPositionPassed() {
            return this.authorized_representative_1.fields?.job_position?.passed
        },
        jobPositionFailureReason() {
            return this.authorized_representative_1.fields?.job_position?.failure_reason
        },
        jobPositionTooltip() {
            return this.jobPositionPassed ? 'Passed' : this.jobPositionFailureReason
        },
        businessTitlePassed() {
            return this.authorized_representative_1.fields?.business_title?.passed
        },
        businessTitleFailureReason() {
            return this.authorized_representative_1.fields?.business_title?.failure_reason
        },
        businessTitleTooltip() {
            return this.businessTitlePassed ? 'Passed' : this.businessTitleFailureReason
        },
        disableRejectButton() {
            /**
             * NOTICE ON PREVETTING
             * We are currently not using the prevetting process
             */
            return true
        },
        disableSubmitButton() {
            /**
             * NOTICE ON PREVETTING
             * We are currently not using the prevetting process
             */
            return true
        },
    },
    watch: {
        selected_a2p_profile_bundle_id() {
            this.getA2pBrandInformation()
        }
    },
};
</script>
